import './index.css';
import { plusIcon } from '../../assets';
import { useState, useContext } from 'react';
import { TextArea } from '../TextArea';
import CallStore from '../../stores/CallStore';
import { observer } from 'mobx-react';
import strings from '../../localization';
import UploadStore from '../../stores/UploadStore';
import MainStore from '../../stores/MainStore';
import { SelffixLoadingContext } from '../../contexts/SelffixLoadingContext';
import { ModalAlertContext } from '../../contexts/ModalAlertContext';

const TechCallSessionNotes = ({ showImages = true, textAreaStyle }) => {
  const { showSelffixLoading, closeSelffixLoading } = useContext(SelffixLoadingContext);
  const { showModalAlert, closeModalAlert } = useContext(ModalAlertContext);

  const handleAddImage = (e) => {
    showSelffixLoading();
    const file = e.target.files[0];
    UploadStore.uploadFileToCall(file, CallStore.call?.slug).then((response) => {
      if (response.success) {
        UploadStore.addSessionNotesFile({
          ...response.data,
          type: 'note'
        });
      } else {
        showModalAlert({
          title: strings.error,
          message: response.message,
          type: 'error',
          confirmText: strings.ok,
          onCancel: null,
          onConfirm: () => {
            closeModalAlert();
          }
        });
      }
      closeSelffixLoading();
    });
  };


  const images = UploadStore.sessionNotesFiles || [];

  const numberOfImages = images.filter((image) => image.type === 'note').length;

  const sessionNotes = CallStore.call?.note || '';

  const setSessionNotes = (notes) => {
    CallStore.setCall({ ...CallStore.call, note: notes });
  }

  return (
    <div className="tech-call-session-notes">

      <div className="tech-call-session-notes-textarea">
        <TextArea value={sessionNotes} textAreaStyle={textAreaStyle}
          label={strings.notes} onChange={setSessionNotes} placeholder={strings.enterYourNotesHere} />
      </div>
      {showImages && <div className="tech-call-session-notes-images">
        {numberOfImages > 0 && <span className="tech-call-session-notes-images-title">{strings.attachedImages}</span>}
        <div className="tech-call-session-notes-images-list">
          {images.map((image, index) => (
            image.type === 'note' && image.presignedUrl && <div className="tech-call-session-notes-images-list-item" key={index}
              onClick={() => MainStore.setImageModalData(image)}
            >
              <img src={image.presignedUrl} alt="image" />
            </div>
          ))}
        </div>
        <button className="tech-call-session-notes-add-image button-cta button-cta-small" onClick={() => document.getElementById('imageInput').click()}>
          <input id="imageInput" type="file" accept="image/*" onChange={handleAddImage} style={{ display: 'none' }} />
          <img src={plusIcon} alt="plus" />
          <span>{strings.addImage}</span>
        </button>
      </div>
      }
    </div>
  );
};

export default observer(TechCallSessionNotes);